import React from 'react';

export default function SearchIcon() {
  return (
    <>
      <circle cx="11" cy="11" r="8" />
      <path d="m21 21-4.3-4.3" />
    </>
  );
}
